import { ConfigService } from '@axo/config/ConfigService';
import { consent_api } from '@axo/shared/data-access/api';
import { getTermsVersion } from '@axo/shared/util/string';
import { Handler } from '../api-orchestrator';
import { IPreconditions } from '../types/IPreconditions';

type TermsAndConditions = {
  tc_type: 'GENERAL_TERMS' | 'DATA_RETENTION' | 'CREDIT_STATUS';
  version: string;
  _publish_on: string;
};

interface IDependencies {
  postConsent: typeof consent_api.sendMasterConsent;
}

export const consentHandlerFactory =
  ({
    postConsent,
  }: IDependencies): Handler<
    { terms: TermsAndConditions[]; originAction: string },
    IPreconditions
  > =>
  async ({ data, preconditions, baseUrl }) => {
    if (!preconditions.customerId || !preconditions.customerJWT || !data.terms)
      return { didSync: false };

    const api = {
      url: { service: baseUrl },
      token: preconditions.customerJWT,
    };

    const {
      brand,
      country,
      i18n: { defaultLocale },
    } = ConfigService.get('global');

    const requests = [];
    for (const consent of data.terms) {
      const version = getTermsVersion(consent, brand);

      const consentData = {
        Country: country ?? '',
        OriginBrandID: brand ?? '',
        ExternalVersion: version,
        Lang: defaultLocale.split('-').at(1) ?? 'en',
        CustomerID: preconditions.customerId,
        OriginAction: data.originAction,
      };

      requests.push(
        postConsent(api)({
          ...consentData,
          ConfigType: consent.tc_type,
        })
      );
    }

    await Promise.all(requests);

    return {
      didSync: true,
    };
  };
